import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// css files
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import './assets/style/style.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

